
import React from 'react';
import { useLocation } from 'react-router-dom';

const MapSection = () => {

  const location = useLocation();
  const isperungudi = location.pathname === '/perungudi-chennai' || location.pathname === '/affordable-coworking-space-perungudi' || location.pathname === '/virtual-office-perungudi';

  return (
    <section className="w-full py-8 sm:py-16">
      <div className="max-w-[75rem] mx-auto px-4 sm:px-6">
        <div className="w-full h-[300px] sm:h-[450px] overflow-hidden rounded-xl">
          {isperungudi ?
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d971.9779912664986!2d80.24640626952228!3d12.977482306059839!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTLCsDU4JzM4LjkiTiA4MMKwMTQnNDkuNCJF!5e0!3m2!1sen!2sin!4v1756197622480!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen={true}
              loading="lazy"
              title="Offisbay Location"
              className="w-full h-full"
              ></iframe> :
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d250.6132027997204!2d80.25717915351039!3d13.05670811220717!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a526700181d6829%3A0xf67714a160ae1be3!2sOffisbay!5e0!3m2!1sen!2sin!4v1747921269993!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen={true}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Offisbay Location"
              className="w-full h-full"
            ></iframe>}

        </div>
      </div>
    </section>
  );
};

export default MapSection;
